import { usePagename } from "../../Hooks/usePagename";

import { useState, useEffect } from "react";

import { useParams, useNavigate } from "react-router-dom";

import { useSearchParams } from "react-router-dom";

import { useQuery } from "@apollo/client";

import { CREATE_ORDER } from "../../Mutations/Orders";

import { DELIVERY_PLANS } from "../../Queries/Orders";

import useCreate from "../../Hooks/Mutations/useCreate";

import useCart from "../../Hooks/Cart/useCart";

import Breadcrumbs from "../../Components/Dashboard/Breadcrumbs";

import OrderSettings from "../../Components/Dashboard/Orders/Single/Aside/OrderSettings";

import PaymentSettings from "../../Components/Dashboard/Orders/Single/Aside/PaymentSettings";

import MontageSettings from "../../Components/Dashboard/Orders/Single/Aside/MontageSettings";

import DeliverySettings from "../../Components/Dashboard/Orders/Single/Aside/DeliverySettings";

import Customer from "../../Components/Dashboard/Orders/Single/Customer";

import DeliveryInformationSettings from "../../Components/Dashboard/Orders/Single/DeliveryInfoSettings";

import NotesSettings from "../../Components/Dashboard/Orders/Single/NotesSettings";

import OrderProducts from "../../Components/Dashboard/Orders/Single/Products";

import OrderProductModal from "../../Components/Dashboard/Products/Collection/Modals/OrderProduct/Modal";

import CreateAction from "../../Components/Dashboard/Orders/Single/Aside/CreateAction";

import CustomerSearch from "../../Components/Dashboard/Orders/Single/Search";

import ConfirmationAction from "../../Components/Dashboard/Orders/Single/ConfirmationAction";

/**
 * 
 * @exports CreateOrder
 * 
 * @description CreateOrder component.
 * 
 * @param { Object } props - The props object.
 * 
 * @param { String } props.name - The name of the page.
 * 
 * @example <CreateOrder name="Create Order" />
 * 
 * @returns { JSX.Element } CreateOrder
 * 
 */

export default function CreateOrder ( { name } ) { usePagename ( name ); const 

    /** 
     * 
     * @description Utility hooks. 
     * 
     */

    { checkout } = useParams (),

    { clearCart } = useCart (),

    navigate = useNavigate (),

    [ searchParams ] = useSearchParams (),
  
    getOrderType = searchParams.get ( "order" ),

    /** 
     * 
     * @type { Object } state 
     * 
     */

    [ state, setState ] = useState ( 
        
        {

            orderType: "",

            status: "",

            paymentMethod: "",

            orderPaymentNotes: "",

            vatIncluded: true,

            hideTotalsInPdf: false,

            assembly: false,

            assemblyPrice: 0, 

            orderDeliveryNotes: "",

            deliveryPrice: 0,

            deliveryPlanId: 0,

            firstName: "",

            lastName: "",

            mobilePhoneNr: "",

            email: "",

            customerIdCode: "",

            companyName: "",

            regNr: "",

            pvnRegNr: "",

            bank: "",

            bankSwift: "",

            bankIban: "",

            adminNotes: "",

            userNotes: "",

            countryCode: "",

            city: "",

            address: "",

            postCode: "",

            shippingNotes: "",

            orderProductVendors: checkout === "checkout" ? JSON.parse ( localStorage.getItem ( "cart" ) ) : [],

            customDeliveryPrice: 0,

            userId: ""

        } 
    
    ),

    /**
     * 
     * @event createMutation
     * 
     * @description Create order mutation.
     * 
     */

    { createMutation, loading, complete, returnData, errors, setErrors } = useCreate ( CREATE_ORDER ),

    /**
     * 
     * @event useQuery
     * 
     * @description Fetch delivery plans to set default tireshop_pickup.
     * 
     */

    { data: deliveryPlansData } = useQuery ( DELIVERY_PLANS ),

    /**
     * 
     * @event submit
     * 
     * @description Submit form.
     * 
     * @param { Event } e
     * 
     * @returns { void }
     * 
     * @example <form onSubmit={ submit } />
     * 
     */

    submit = ( e ) => { e.preventDefault ();

        /** If required fields are not filled, set errors to true. */

        if ( ! state.firstName ) { return setErrors ( { message: "Missing first name" } ); }

        if ( ! state.lastName ) { return setErrors ( { message: "Missing last name" } ); }

        if ( ! state.email ) { return setErrors ( { message: "Missing email" } ); }

        if ( ! state.mobilePhoneNr ) { return setErrors ( { message: "Missing mobile phone number" } ); }

        if ( ! state.orderType ) { return setErrors ( { message: "Missing order type" } ); }

        if ( ! state.status ) { return setErrors ( { message: "Missing status" } ); }

        if ( ! state.userId ) { return setErrors ( { message: "Missing user ID" } ); }

        // Delivery plan is optional - backend will set default if not provided
        // if ( state.deliveryPlanId === null || state.deliveryPlanId === undefined || state.deliveryPlanId === "" ) { 
        //     return setErrors ( { message: "Missing delivery plan. Please select a delivery method." } ); 
        // }

        const submitState = optimizeState ( state );

        createMutation ( submitState );

    };

    /**
     * 
     * @event useEffect
     * 
     * @description If complete, navigate to order edit page and clear cart.
     * 
     * @returns { void }
     * 
     */

    /**
     * 
     * @event useEffect
     * 
     * @description Set default delivery plan to tireshop_pickup when delivery plans are loaded.
     * Only sets if deliveryPlanId is not already set (0, null, or undefined).
     * 
     */

    useEffect ( () => {

        if ( deliveryPlansData?.deliveryPlans && ( ! state.deliveryPlanId || state.deliveryPlanId === 0 ) ) {

            const pickupPlan = deliveryPlansData.deliveryPlans.find ( 
                plan => plan.planId === "tireshop_pickup" && plan.enabled 
            );

            if ( pickupPlan ) {

                setState ( prevState => ( { 
                    ...prevState, 
                    deliveryPlanId: parseInt ( pickupPlan.id ),
                    deliveryPrice: 0
                } ) );

            }

        }

    }, [ deliveryPlansData, state.deliveryPlanId ] );

    /**
     * 
     * @event useEffect
     * 
     * @description If complete, navigate to order edit page and clear cart.
     * 
     * @returns { void }
     * 
     */

    useEffect ( () => {

        if ( complete === true && returnData?.adminCreateOrder?.order ) {
        
            const orderId = returnData.adminCreateOrder.order.id;
            const availableDeliveryMethods = returnData.adminCreateOrder.order.availableDeliveryMethods || [];
            
            // Navigate to edit page with availableDeliveryMethods in state via URL params or pass via location state
            // The edit page will fetch the order, but we can also pass the methods via navigation state
            navigate ( `/app/orders/edit/${ orderId }`, {
                state: {
                    availableDeliveryMethods: availableDeliveryMethods
                }
            } );

            clearCart ();

        }
            
    }, [ complete, returnData ] );

    console.log(state)

    /** @returns { JSX.Element } CreateOrder */

    return (

        <section className="mutations create_order">

            <Breadcrumbs />

            <form onSubmit={ submit }>

                <div className="aside-edit">

                    <div className="content">

                        <CustomerSearch state={ state } update={ setState } />

                        <Customer state={ state } update={ setState } />

                        <DeliveryInformationSettings state={ state } update={ setState } />

                        <OrderProductModal orderData={ { view: state, set: setState } } />

                        <OrderProducts order={ state } setState={ setState } />

                        <NotesSettings state={ state } update={ setState } />

                        <ConfirmationAction errors={ errors } loading={ loading } />

                    </div>

                    <aside>

                        <CreateAction errors={ errors } loading={ loading } />

                        <OrderSettings state={ state } update={ setState } orderType={ getOrderType } />

                        <DeliverySettings state={ state } update={ setState } orderType={ getOrderType } />

                        <PaymentSettings state={ state } update={ setState } />

                        <MontageSettings state={ state } update={ setState } />

                        <ConfirmationAction errors={ errors } loading={ loading } />

                    </aside>

                </div>

            </form>

        </section>

    );

};

/**
 * 
 * @function optimizeState
 * 
 * @description Optimize state.
 * 
 * @param { Object } obj - The object to optimize.
 * 
 * @returns { Object } state
 * 
 * @example const state = optimizeState ( obj );
 * 
 */

export function optimizeState ( obj ) {

    /** @event optimizeState */

    const productInput = obj.orderProductVendors.map ( el => ( { productId: parseInt ( el.productId ), discount: parseFloat ( el.discount || "0" ), price: parseFloat ( el.price ), count: parseInt ( el.count )} ) );

    /** @event return state */
    
    // If deliveryPlanId is 0, null, or undefined, set it to null (backend will set default)
    const optimizedState = { ...obj, productInput };
    
    if ( ! optimizedState.deliveryPlanId || optimizedState.deliveryPlanId === 0 ) {
        optimizedState.deliveryPlanId = null;
    }

    return optimizedState;

}